module.exports = __webpack_public_path__ + "assets/99873266204544df19c8ada364bdc397.jpg";